
const usernameCharacters = /^[a-zA-Z0-9._-]{3,64}$/
export function validateUsername(str: string) {
    return usernameCharacters.test(str)
}